// Dynamic imports
const AssistantList = () => import('@/views/assistants/AssistantList.vue')
const AssistantForm = () => import('@/views/assistants/AssistantForm.vue')
const AssistantView = () => import('@/views/assistants/AssistantView.vue')

export const assistantRoutes = [
  {
    path: '/assistants',
    name: 'AssistantList',
    component: AssistantList,
    meta: {
      requiresAuth: true,
      requiresSuperAdmin: true,
      title: 'Assistants'
    }
  },
  {
    path: '/assistants/new',
    name: 'NewAssistant',
    component: AssistantForm,
    meta: {
      requiresAuth: true,
      requiresSuperAdmin: true,
      title: 'New Assistant'
    }
  },
  {
    path: '/assistants/:id/edit',
    name: 'EditAssistant',
    component: AssistantForm,
    meta: {
      requiresAuth: true,
      requiresSuperAdmin: true,
      title: 'Edit Assistant'
    }
  },
  {
    path: '/assistants/:id',
    name: 'ViewAssistant',
    component: AssistantView,
    meta: {
      requiresAuth: true,
      requiresSuperAdmin: true,
      title: 'Assistant Details'
    }
  }
  // Additional routes will be added later
]
